import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";


async function ListadoAlertasPreviasService(idUsuario) {

    try {
        return await instance.Backend.post("/Indicador/ListaAlertasPrevias", 
        {
            IdUsuario: idUsuario
        }, customConfig);

    } catch (error) {
        console.log(error);
    }

}
export { ListadoAlertasPreviasService };